import { TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import Theme from 'App.theme';

const InputField = withStyles({
  root: {
    '& .MuiFormLabel-root': {
      fontFamily: Theme.font,
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: Theme.greys.GREY0,
      fontFamily: Theme.font,
      borderRadius: '1rem',

      '& fieldset': {
        borderColor: Theme.greys.GREY0,
      },
      '&:hover': {
        '& fieldset': {
          borderColor: Theme.greys.GREY1,
        },
      },

      '&.Mui-focused fieldset': {
        borderColor: Theme.greys.GREY1,
      },
      '&.Mui-disabled fieldset': {
        borderColor: Theme.greys.GREY0,
      },
    },
  },
})(TextField);

export default InputField;
